<template>
  <div>
    <h1>Cart</h1>
    <table class="table" v-if="cart.length > 0">
      <thead>
        <tr>
          <td>Product Name</td>
          <td>Price</td>
          <td>Quantity</td>
          <td>Total</td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="cartItem in cart" :key="cartItem.id">
          <td>{{ cartItem.title }}</td>
          <td>{{ cartItem.price | priceFormatter }}</td>
          <td>
            <button @click="incrementItemQuantity(cartItem.id)">
              <font-awesome-icon icon="plus" />
            </button>

            {{ cartItem.quantity }}
            <button @click="decrementItemQuantity(cartItem.id)">
              <font-awesome-icon icon="minus" />
            </button>
          </td>
          <td>{{ cartItem.total | priceFormatter }}</td>
          <td>
            <button @click="removeProductFromCart(cartItem.id)">
              <font-awesome-icon icon="trash" />
              <!-- https://fontawesome.com/icons?d=gallery&q=plus&s=solid&m=free -->
              <!-- https://codehack.dev/vuefontawesomecheatsheet/ -->
            </button>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            Total
          </td>
          <td>{{ total | priceFormatter }}</td>
          <td colspan="3" class="clearCart">
            <button @click="clearCart">Clear cart</button>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else>No items in the cart.</p>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  computed: {
    cart() {
      return this.$store.state.cart;
    },
    total() {
      return this.$store.state.cart
        .map(li => li.total)
        .reduce((sum, val) => sum + val, 0);
    }
  },
  methods: {
    ...mapActions([
      "removeProductFromCart",
      "incrementItemQuantity",
      "decrementItemQuantity"
    ]),
    clearCart: function() {
      // this is just to demo commit here. but it is better to commit in store using map action like above.
      this.$store.commit("clearCart");
      this.$swal({
        title: "Cart cleared!",
        icon: "success",
        button: "Done!"
      });
    }
  }
};
</script>

<style scoped>
button {
  padding: 0;
  border: none;
  background: none;
}
</style>
